import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Download, MapPin } from "lucide-react";
import { api, API_BASE } from "@/lib/api";

export default function PublicReport() {
  const { slug } = useParams();
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get(`/reports/public/${slug}`)
      .then((r) => setReport(r.data))
      .catch(() => setError("Laporan tidak ditemukan"));
  }, [slug]);

  if (error)
    return (
      <main className="public-shell">
        <div className="public-card">
          <h1>Laporan tidak ditemukan</h1>
          <Link to="/">← Kembali ke dashboard</Link>
        </div>
      </main>
    );
  if (!report)
    return (
      <main className="public-shell">
        <div className="public-card">Memuat laporan...</div>
      </main>
    );

  return (
    <main className="public-shell" data-testid="public-report">
      <Link to="/" className="public-back">
        <ArrowLeft size={16} /> Dashboard
      </Link>
      <article className="public-card">
        <span className={`sev sev-${report.severity.toLowerCase()}`}>
          {report.severity}
        </span>
        <p className="eyebrow">
          SITAKO · LAPORAN KEJADIAN #{report.public_slug.toUpperCase()}
        </p>
        <h1>{report.title}</h1>
        <div className="pr-meta">
          <div>
            <span>Jenis</span>
            <b>{report.incident_type.replace("_", " ")}</b>
          </div>
          <div>
            <span>Wilayah</span>
            <b>Kecamatan {report.district}</b>
          </div>
          <div>
            <span>Waktu kejadian</span>
            <b>{new Date(report.happened_at).toLocaleString("id-ID")}</b>
          </div>
          <div>
            <span>Pelapor</span>
            <b>{report.reporter || "—"}</b>
          </div>
          {report.lat && report.lng && (
            <div>
              <span>Koordinat</span>
              <b>
                <MapPin size={12} /> {report.lat}, {report.lng}
              </b>
            </div>
          )}
        </div>
        <section>
          <h3>Uraian kejadian</h3>
          <p>{report.description}</p>
        </section>
        {report.actions_taken && (
          <section>
            <h3>Tindakan yang dilakukan</h3>
            <p>{report.actions_taken}</p>
          </section>
        )}
        <a
          className="public-download"
          href={`${API_BASE}/reports/${report.id}/pdf`}
          target="_blank"
          rel="noreferrer"
          data-testid="download-pdf"
        >
          <Download size={15} /> Unduh laporan PDF
        </a>
        <footer>
          Diterbitkan BPBD Kabupaten Kayong Utara ·{" "}
          {new Date(report.created_at).toLocaleString("id-ID")}
        </footer>
      </article>
    </main>
  );
}
